import { Checkbox, Heading } from '@assembly-js/design-system';
import { useFormikContext } from 'formik';

import { LineItemFormSchema } from 'src/routes/billing/components/LineItemEditorV2/LineItem/Presentation';
import { LineItemType } from 'src/services/api/invoicesApi';

type Props = {
  label: string;
  lineItem: LineItemFormSchema;
  fieldName: string;
};

export function AddProductRenderer({ label, lineItem, fieldName }: Props) {
  const { setFieldValue } = useFormikContext();
  const shouldAddProductFieldName = `${fieldName}.shouldAddProduct`;
  const shouldAddProduct =
    lineItem.type === LineItemType.OneTime && lineItem.shouldAddProduct;

  return (
    <div>
      <div className="mb-2  ">
        <div className="flex items-center gap-2">
          <label className="flex items-center">
            <Checkbox
              checked={!!shouldAddProduct}
              onChange={() =>
                setFieldValue(shouldAddProductFieldName, !shouldAddProduct)
              }
              classes={{
                input: 'h-4 w-4',
              }}
              label=""
            />
            <Heading className="leading-[22px] text-dark-heading">
              Add to products
            </Heading>
          </label>
        </div>
        <div className="text-[12px] mt-0.5 text-gray-small pl-6">
          Adding this item to your products will allow you to use it again in
          other {label}
        </div>
      </div>
    </div>
  );
}
